<template>
  <div class="wrap">
  </div>
</template>
<script>
export default {
  name: "cardDecoration",
  data() {
    return {};
  },
  methods: {
  }
};
</script>
